import React, { useEffect, useState } from 'react';
import { Collapse } from '@material-ui/core';
import styled from 'styled-components/macro';
import ErrorIcon from '@material-ui/icons/Error';
import ListBuilder from './ListBuilder';
import InputBase from '@material-ui/core/InputBase';
const Error = styled.div`
  color: ${({ theme }) => theme.palette.error.dark};
  text-align: left;

  svg {
    display: inline-block;
    vertical-align: middle;
    margin: 0 0.5ch 0 0;
  }
`;

const SingleOptionContainer = styled.div`
  max-height: 20vh;
  overflow: auto;
  div {
    width: 100%;
  }
  input {
    font-size: 14px;
  }
`;
const findDuplicates = arr =>
  arr
    .map(s => s.trim())
    .filter(Boolean)
    // get duplicates
    .filter((item, index, self) => self.indexOf(item) !== index)
    // remove duplicates of duplicates
    .filter((item, index, self) => self.indexOf(item) === index);

const removeDuplicates = arr =>
  arr
    .map(s => s.trim())
    .filter(Boolean)
    // keep items that are not duplicates
    .filter((item, index, self) => self.indexOf(item) === index);

const OptionsBuilder = ({
  options = [],
  onChange,
  allowDuplicates = false,
  disabled,
  singleOption,
  emojiTargetRef,
  htmlId = '',
  dontUpdateValue
}) => {
  const [rawOptions, setRawOptions] = useState([]);
  const [listValue, setListValue] = useState(options ? options.join('\n') : '');
  const duplicates = !allowDuplicates && findDuplicates(rawOptions);
  const hasDuplicates = duplicates && duplicates.length > 0;
  const noValidOptions = !options.some(o => Boolean(o.trim()));

  const [singleOptionValue, setSingleOptionValue] = useState(options[0] || '');

  useEffect(() => {
    let newOptions = [...options];
    if (singleOption) {
      if (singleOptionValue !== options.join('\n')) {
        setSingleOptionValue(options.join('\n'));
      }
    } else {
      if (rawOptions.join('\n') !== options.join('\n')) {
        setListValue(newOptions.join('\n'));
        setRawOptions(newOptions);
      }
    }
  }, [options]);

  return (
    <>
      {singleOption ? (
        <>
          <SingleOptionContainer>
            <InputBase
              style={{ fontSize: 14 }}
              placeholder="▪ Add checkbox text"
              inputProps={{ 'data-testid': `option-builder-${htmlId}` }}
              value={singleOptionValue}
              multiline
              onChange={e => {
                const value = e.target.value || '';
                const breakOperation = onChange([value]);
                if (breakOperation) {
                  return;
                }
                setSingleOptionValue(value);
              }}
              onFocus={e => {
                emojiTargetRef.current = e.target;
              }}
            />
          </SingleOptionContainer>
          <Collapse in={noValidOptions}>
            <Error>
              <ErrorIcon />
              {'Please add an option.'}
            </Error>
          </Collapse>
        </>
      ) : (
        <>
          <ListBuilder
            dontUpdateValue={dontUpdateValue}
            onChange={v => {
              const breakOperation = onChange(removeDuplicates(v.split('\n')));
              if (breakOperation) {
                return;
              }
              setRawOptions(v.split('\n'));
            }}
            value={listValue}
            disabled={disabled}
            maxHeight="20vh"
            emojiTargetRef={emojiTargetRef}
            htmlId={htmlId}
          />

          <Collapse in={hasDuplicates}>
            {hasDuplicates &&
              (duplicates.length > 1 ? (
                <Error>
                  <ErrorIcon />
                  {'Duplicate options: ' + duplicates.join(', ')}
                </Error>
              ) : (
                <Error>
                  <ErrorIcon />
                  {'Duplicate option: ' + duplicates[0]}
                </Error>
              ))}
          </Collapse>
          <Collapse in={noValidOptions}>
            <Error>
              <ErrorIcon />
              {'Please add at least one option.'}
            </Error>
          </Collapse>
        </>
      )}
    </>
  );
};

export default OptionsBuilder;
